import React from 'react'
import {
  Snackbar,
  Alert,
  AlertColor,
  SnackbarProps
} from '@mui/material'

export interface ToastProps {
  open: boolean
  message: string
  severity?: AlertColor
  onClose: () => void
  autoHideDuration?: number
  anchorOrigin?: SnackbarProps['anchorOrigin']
}

export const Toast: React.FC<ToastProps> = ({
  open,
  message,
  severity = 'error',
  onClose,
  autoHideDuration = 6000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' }
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  )
}